import { render } from "./SoleTraderLimitedCompany.vue?vue&type=template&id=69caa0e2"
import script from "./SoleTraderLimitedCompany.vue?vue&type=script&lang=js"
export * from "./SoleTraderLimitedCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__